/** @flow */
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { Map, FeatureGroup, Circle, Marker, TileLayer, Viewport } from 'react-leaflet';
import Leaflet from 'leaflet';
import Antenna from 'statsradio/domain/Antenna';

type Props = {
  antennas: Antenna[],
  viewport: ?Viewport,
  onViewportChange: (viewport: Viewport) => void,
  theme: any,
}

type State = {
  bounds: Leaflet.LatLngBounds
}

const StyledMap = styled(Map)`
  z-index: 0;
  height: 350px;
`;

const ICON_MARKER = Leaflet.icon(
  {
    iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-black.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  },
);

class GeoMapByAntenna extends React.Component<Props, State> {

  state = { bounds: [[0, 0], [0, 0]] };

  onFeatureGroupAdd = (event: Object): void => {
    const bounds = event.target.getBounds();
    this.setState({ bounds });
  }

  onViewReset = ({ target: map }) => {
    const center = map.getCenter();
    const zoom = map.getZoom();
    this.props.onViewportChange({ center, zoom });
  }

  render() {
    const { antennas, theme, viewport, onViewportChange = (v) => { } } = this.props;
    const bounds = viewport ? undefined : this.state.bounds;

    const featureGroupKeyToForceRender = `${this.props.antennas.reduce((acc, antenna) => acc + `${antenna.latitude}${antenna.longitude}`, '')}`;

    return (
      <StyledMap bounds={bounds} viewport={viewport} scrollWheelZoom={false} onViewportChanged={onViewportChange} onViewReset={this.onViewReset} >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='<a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />
        <FeatureGroup key={featureGroupKeyToForceRender} onAdd={this.onFeatureGroupAdd} >
          {antennas.map((antenna) => {
            const latlng = Leaflet.latLng(antenna.latitude, antenna.longitude);

            return (
              <React.Fragment key={`featureGroup${latlng}`}>
                <Circle
                  center={latlng}
                  fillColor={theme.colors.primary}
                  color={theme.colors.primary}
                  radius={antenna.strengthRadiusInMeters}
                />
                <Marker position={latlng} icon={ICON_MARKER} />
              </React.Fragment>
            );
          },
          )}
        </FeatureGroup>
      </StyledMap>
    );
  }
}

export default withTheme(GeoMapByAntenna);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/components/geolocalisation/map/GeoMapByAntenna.js